export default __webpack_public_path__ + "locales/ro/SalesDepartmentRequestDialog.json?hash=bdef46275fc5002dde73e39a7f0091fe";